import { IAutomationAppComponent } from "../../types";
import { schema } from "./types";
import { OverviewPanel,OperatorPanel,ConfigurationPanel } from '.';
import { IoMdFlash } from "react-icons/io";
import { SideviewPanel } from "./SideviewPanel";
import { CounterType } from "../CounterType";
import { CounterMedium } from "../CounterMedium";
import InsightsPanel from "./InsightsPanel";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: true,
    Icon: IoMdFlash,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    SideViewPanel: SideviewPanel,
    InsightsPanel: InsightsPanel,
    createConfig: {
        group: 'Energy',
            name: "Energy meters, Volume meters",
            description: "Energy meter",
            panel: OverviewPanel,
            defaultState: {  value: 0, dimension: 'kWh', enableCounter: false },
            defaultProperties: [
                { key: 'Dimension', value: 'kWh' },
                { key: 'Value', value: 0 },
                { key: 'CounterType', value: CounterType.Consumer },
                { key: 'CounterMedium', value: CounterMedium.ElectricityMeter },
            ]
    }
}
